import { useState, useEffect, ReactNode } from "react";
import { ShieldAlert } from "lucide-react";

const GEO_API_URL = "https://ipapi.co/json/";

const GeoBlockGuard = ({ children }: { children: ReactNode }) => {
  const [status, setStatus] = useState<"loading" | "allowed" | "blocked">("loading");

  useEffect(() => {
    const checkCountry = async () => {
      try {
        const resp = await fetch(GEO_API_URL);
        if (!resp.ok) {
          // If geo API fails, allow access (fail open)
          setStatus("allowed");
          return;
        }
        const data = await resp.json();
        if (data.country_code === "US" || !data.country_code) {
          setStatus("allowed");
        } else {
          setStatus("blocked");
        }
      } catch {
        // If we can't determine location, allow access
        setStatus("allowed");
      }
    };

    checkCountry();
  }, []);

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (status === "blocked") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="max-w-md text-center space-y-6">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <ShieldAlert className="h-8 w-8 text-destructive" />
          </div>
          <h1 className="font-display text-2xl font-bold text-foreground">
            Service Not Available
          </h1>
          <p className="text-muted-foreground leading-relaxed">
            Hope & Wellness Healing Center is currently only available to visitors
            in the United States. We appreciate your interest and apologize for the
            inconvenience.
          </p>
          <p className="text-sm text-muted-foreground">
            If you believe this is an error, please contact us at{" "}
            <a
              href="mailto:info@hwhctherapy.com"
              className="text-accent underline underline-offset-2"
            >
              info@hwhctherapy.com
            </a>
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default GeoBlockGuard;
